import * as React from 'react';

import * as style from './Subtitle.css';

export interface ISubtitleProps {
  textList: string[];
  isExperimentalLocation: boolean;
}

export const SubtitleComponent: React.FC<ISubtitleProps> = props => {
  const { textList, isExperimentalLocation } = props;

  // TODO удалить после подтверждения https://jira.cian.tech/browse/OM-912
  /* istanbul ignore next */
  const seoListClassName = React.useMemo(
    () => (isExperimentalLocation ? style['container-experimental'] : style['container']),
    [isExperimentalLocation],
  );

  return (
    <ul data-testid="Subtitle" className={seoListClassName}>
      {textList.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
};

export const Subtitle = React.memo(SubtitleComponent);
